import { render, staticRenderFns } from "./TableGaau.vue?vue&type=template&id=c1e5ef6c&"
import script from "./TableGaau.vue?vue&type=script&lang=js&"
export * from "./TableGaau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports